import React from "react";
import {
  StyledExplainerBar,
} from "./StyledExplainerBar";

const ExplainerBar = ({ text = "", fontStyle = "italic" }) => {
  if (!text) {
    return null;
  }

  return (
    <StyledExplainerBar fontStyle={fontStyle} className="mls-c-explainer-bar">
      {text}
    </StyledExplainerBar>
  );
};

export default ExplainerBar;
